module.exports = __webpack_public_path__ + "static/media/Jon-Mckee.442c001b.jpg";